<template>
    <!--dialog open on updateTaskPlanDialog set to true-->
    <v-dialog
        v-if="updateTaskPlanDialog"
        v-model="updateTaskPlanDialog"
        persistent
        width="1200px"
    >
        <v-form ref="updateTaskPlanForm">
            <v-card :loading="isLoadingQuery">
                <!-- V-card-title-->
                <v-card-title
                    class="primary white--text"
                    :loading="isLoadingQuery"
                >
                    <v-icon dark class="mr-2">event</v-icon>Task Plan
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        dark
                        @click="addPhase"
                        :loading="isLoadingQuery"
                    >
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-card-title>
                <!-- v-card-text -->
                <v-card-text class="pb-0">
                    <v-toolbar class="py-2" outlined flat>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-toolbar-title class="title pr-2" v-on="on">
                                    {{
                                        growthTask != null
                                            ? growthTask.plant.name
                                            : ""
                                    }}
                                    <div
                                        class="
                                            mt-n1
                                            grey--text
                                            text--darken-1
                                            caption
                                        "
                                        v-if="growthTask"
                                    >
                                        {{
                                            (growthTask
                                                ? growthTask.growthStartDate
                                                : "1970-01-01")
                                                | moment("YYYY-[W]WW")
                                        }}
                                    </div>
                                </v-toolbar-title>
                            </template>
                            <span>{{
                                growthTask != null ? growthTask.plant.name : ""
                            }}</span>
                        </v-tooltip>

                        <v-spacer />
                        <v-icon
                            :color="taskColor"
                            v-if="growthTask && growthTask.plant.name"
                            class="mr-1"
                            >eco</v-icon
                        >
                        <span class="title">{{
                            growthTask ? growthTask.totalInventory : ""
                        }}</span>
                    </v-toolbar>

                    <!-- phases -->
                    <v-card-text
                        class="px-0"
                        v-if="growthTask && growthTask.growthTaskPhaseSet"
                    >
                        <v-row
                            v-for="(phase, index) in growthTaskPhases"
                            v-bind:key="index"
                            class="ma-0 pa-0"
                        >
                            <v-container
                                v-if="$vuetify.breakpoint.smAndDown"
                                fluid
                                class="pa-0"
                            >
                                <v-row align="center" class="pt-0 mt-0">
                                    <v-divider class="ml-5"></v-divider>
                                    <span
                                        class="pl-3 pr-3 pt-0 "
                                        v-if="phase.node.isSalesPhase"
                                        >Sales</span
                                    >
                                    <span v-else class="pl-3 pr-3 pt-0 "
                                        >Phase {{ phase.node.phaseNo }}</span
                                    >
                                    <v-divider class="mr-5"></v-divider>
                                </v-row>
                                <v-row class="mx-0 px-0">
                                    <v-col cols="4">
                                        <v-menu
                                            v-model="phase.node.startDatePicker"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                            :disabled="
                                                phase.node.phaseNo <
                                                    currentPhase.phaseNo
                                            "
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="
                                                        phase.node.startDate
                                                    "
                                                    label="Start Date"
                                                    :disabled="
                                                        phase.node.phaseNo <
                                                            currentPhase.phaseNo
                                                    "
                                                    :rules="[
                                                        rules.startDateRule(
                                                            index
                                                        )
                                                    ]"
                                                    :background-color="
                                                        phase.node
                                                            .isCurrentPhase
                                                            ? phase.node
                                                                  .isSalesPhase
                                                                ? `orange lighten-4`
                                                                : `green lighten-4`
                                                            : ``
                                                    "
                                                    readonly
                                                    outlined
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="phase.node.startDate"
                                                first-day-of-week="1"
                                                locale-first-day-of-year="4"
                                                no-title
                                                show-week
                                                @input="
                                                    onPhaseStartDateChanged(
                                                        phase.node
                                                    )
                                                "
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                            v-model="phase.node.numDays"
                                            :rules="[rules.required]"
                                            type="number"
                                            min="1"
                                            label="Days*"
                                            outlined
                                            @input="
                                                onPhaseNumDaysChanged(
                                                    phase.node
                                                )
                                            "
                                            :background-color="
                                                phase.node.isCurrentPhase
                                                    ? phase.node.isSalesPhase
                                                        ? `orange lighten-4`
                                                        : `green lighten-4`
                                                    : ``
                                            "
                                            class="subtitle-2"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                            v-model="phase.node.numPlantsPerM2"
                                            :rules="[rules.required]"
                                            type="number"
                                            min="1"
                                            label="#Plants / m2*"
                                            outlined
                                            :disabled="
                                                phase.node.phaseNo <
                                                    currentPhase.phaseNo
                                            "
                                            :background-color="
                                                phase.node.isCurrentPhase
                                                    ? phase.node.isSalesPhase
                                                        ? `orange lighten-4`
                                                        : `green lighten-4`
                                                    : ``
                                            "
                                            class="subtitle-2"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                            :value="
                                                calculateSpaceM2(
                                                    phase.node.numPlantsPerM2,
                                                    growthTask.totalInventory
                                                )
                                            "
                                            type="number"
                                            label="Space m2*"
                                            outlined
                                            disabled
                                            :background-color="
                                                phase.node.isCurrentPhase
                                                    ? phase.node.isSalesPhase
                                                        ? `orange lighten-4`
                                                        : `green lighten-4`
                                                    : ``
                                            "
                                            class="subtitle-2"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-autocomplete
                                            v-model="
                                                phase.node
                                                    .greenhouseDepartmentSection
                                                    .id
                                            "
                                            :rules="[rules.required]"
                                            :items="
                                                greenhouseDepartmentSections
                                            "
                                            :loading="
                                                phase.node.phaseNo <
                                                currentPhase.phaseNo
                                                    ? false
                                                    : $apollo.queries
                                                          .greenhouses.loading
                                            "
                                            item-value="id"
                                            item-text="name"
                                            label="Greenhouse*"
                                            class="subtitle-2"
                                            outlined
                                            :disabled="
                                                phase.node.phaseNo <
                                                    currentPhase.phaseNo
                                            "
                                            :background-color="
                                                phase.node.isCurrentPhase
                                                    ? phase.node.isSalesPhase
                                                        ? `orange lighten-4`
                                                        : `green lighten-4`
                                                    : ``
                                            "
                                        >
                                            <template
                                                slot="selection"
                                                slot-scope="{ item }"
                                                >{{ item.fullName }}</template
                                            >
                                            <template
                                                slot="item"
                                                slot-scope="{ item }"
                                                >{{ item.fullName }}</template
                                            >
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="2" align="center" class="pt-5">
                                        <v-btn
                                            icon
                                            :disabled="
                                                phase.node.phaseNo == 1 ||
                                                    phase.node.phaseNo <
                                                        currentPhase.phaseNo ||
                                                    phase.node.isSalesPhase
                                            "
                                            @click="deletePhase(phase.node)"
                                        >
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                            <v-container v-else fluid class="py-0">
                                <v-row align="center" class="pt-0 mt-0">
                                    <v-divider></v-divider>
                                    <span
                                        class="pl-3 pr-3 pt-0 "
                                        v-if="phase.node.isSalesPhase"
                                        >Sales</span
                                    >
                                    <span v-else class="pl-3 pr-3 pt-0 "
                                        >Phase {{ phase.node.phaseNo }}</span
                                    >
                                    <v-divider></v-divider>
                                </v-row>
                                <v-row>
                                    <v-col cols="3">
                                        <v-menu
                                            v-model="phase.node.startDatePicker"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                            :disabled="
                                                phase.node.phaseNo <
                                                    currentPhase.phaseNo
                                            "
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="
                                                        phase.node.startDate
                                                    "
                                                    label="Start Date"
                                                    :disabled="
                                                        phase.node.phaseNo <
                                                            currentPhase.phaseNo
                                                    "
                                                    :rules="[
                                                        rules.startDateRule(
                                                            index
                                                        )
                                                    ]"
                                                    :background-color="
                                                        phase.node
                                                            .isCurrentPhase
                                                            ? phase.node
                                                                  .isSalesPhase
                                                                ? `orange lighten-4`
                                                                : `green lighten-4`
                                                            : ``
                                                    "
                                                    readonly
                                                    outlined
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="phase.node.startDate"
                                                first-day-of-week="1"
                                                locale-first-day-of-year="4"
                                                no-title
                                                show-week
                                                @input="
                                                    onPhaseStartDateChanged(
                                                        phase.node
                                                    )
                                                "
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="1">
                                        <v-text-field
                                            v-model="phase.node.numDays"
                                            :rules="[rules.required]"
                                            type="number"
                                            min="1"
                                            label="Days*"
                                            outlined
                                            @input="
                                                onPhaseNumDaysChanged(
                                                    phase.node
                                                )
                                            "
                                            :background-color="
                                                phase.node.isCurrentPhase
                                                    ? phase.node.isSalesPhase
                                                        ? `orange lighten-4`
                                                        : `green lighten-4`
                                                    : ``
                                            "
                                            class="subtitle-2"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field
                                            v-model="phase.node.numPlantsPerM2"
                                            :rules="[rules.required]"
                                            type="number"
                                            min="1"
                                            label="#Plants / m2*"
                                            outlined
                                            :disabled="
                                                phase.node.phaseNo <
                                                    currentPhase.phaseNo
                                            "
                                            :background-color="
                                                phase.node.isCurrentPhase
                                                    ? phase.node.isSalesPhase
                                                        ? `orange lighten-4`
                                                        : `green lighten-4`
                                                    : ``
                                            "
                                            class="subtitle-2"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field
                                            :value="
                                                calculateSpaceM2(
                                                    phase.node.numPlantsPerM2,
                                                    growthTask.totalInventory
                                                )
                                            "
                                            type="number"
                                            label="Space m2*"
                                            outlined
                                            disabled
                                            :background-color="
                                                phase.node.isCurrentPhase
                                                    ? phase.node.isSalesPhase
                                                        ? `orange lighten-4`
                                                        : `green lighten-4`
                                                    : ``
                                            "
                                            class="subtitle-2"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-autocomplete
                                            v-model="
                                                phase.node
                                                    .greenhouseDepartmentSection
                                                    .id
                                            "
                                            :rules="[rules.required]"
                                            :items="
                                                greenhouseDepartmentSections
                                            "
                                            :loading="
                                                phase.node.phaseNo <
                                                currentPhase.phaseNo
                                                    ? false
                                                    : $apollo.queries
                                                          .greenhouses.loading
                                            "
                                            item-value="id"
                                            item-text="name"
                                            label="Greenhouse*"
                                            class="subtitle-2"
                                            outlined
                                            :disabled="
                                                phase.node.phaseNo <
                                                    currentPhase.phaseNo
                                            "
                                            :background-color="
                                                phase.node.isCurrentPhase
                                                    ? phase.node.isSalesPhase
                                                        ? `orange lighten-4`
                                                        : `green lighten-4`
                                                    : ``
                                            "
                                        >
                                            <template
                                                slot="selection"
                                                slot-scope="{ item }"
                                                >{{ item.fullName }}</template
                                            >
                                            <template
                                                slot="item"
                                                slot-scope="{ item }"
                                                >{{ item.fullName }}</template
                                            >
                                        </v-autocomplete>
                                    </v-col>
                                    <v-row>
                                        <v-col cols="1" class="pt-5">
                                            <v-btn
                                                icon
                                                :disabled="
                                                    phase.node.phaseNo == 1 ||
                                                        phase.node.phaseNo <
                                                            currentPhase.phaseNo ||
                                                        phase.node.isSalesPhase
                                                "
                                                @click="deletePhase(phase.node)"
                                            >
                                                <v-icon>delete</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-row>
                            </v-container>
                        </v-row>
                    </v-card-text>
                </v-card-text>
                <!-- Bottom Buttons-->
                <v-card-actions class="mr-5 pb-4">
                    <v-spacer></v-spacer>
                    <v-btn text rounded @click="closeUpdateTaskPlanDialog"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :disabled="!hasPermission('change_growthtask')"
                        outlined
                        rounded
                        color="primary"
                        :loading="isSaving"
                        @click="onUpdateTaskPlanConfirmed"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import helper from "@/utils/helper.js";
import gql from "graphql-tag";
import moment from "moment";

export default {
    name: "UpdateTask",
    props: ["updateTaskPlanDialog", "isLoading"],
    apollo: {
        greenhouses: {
            query: gql`
                query greenhouses {
                    greenhouses {
                        edges {
                            node {
                                id
                                name
                                greenhouseDepartmentSet(
                                    isPlaceholder: false
                                    orderBy: "name"
                                ) {
                                    edges {
                                        node {
                                            id
                                            name
                                            greenhouseDepartmentSectionSet(
                                                isPlaceholder: false
                                                orderBy: "name"
                                            ) {
                                                edges {
                                                    node {
                                                        id
                                                        name
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `,
            variables() {},
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => data.greenhouses,
            skip() {
                return !this.updateTaskPlanDialog;
            },
            pollInterval: 60000 // ms
        }
    },
    data() {
        return {
            growthTasknumber: null,
            // growthTask: { plant: {}, growthTaskPhaseSet: { edges: [] } },
            growthTask: null,
            greenhouses: {},
            growthTaskPhases: [],
            rules: {
                required: v => !helper.isEmpty(v) || "This field is required",
                listRequired: v =>
                    (v || "").length >= 1 || `This field is required`,
                minLength: len => v =>
                    (v || "").length >= len || `Require at least ${len}`,
                maxLength: len => v => (v || "").length <= len || "Too long",
                maxNumber: num => v => (v || 1) <= num || "Out of range",
                startDateRule: index => v =>
                    ((index === 0 ||
                        moment(v).isAfter(
                            this.growthTaskPhases[index - 1].node.startDate
                        )) &&
                        (index === this.growthTaskPhases.length - 1 ||
                            moment(v).isBefore(
                                this.growthTaskPhases[index + 1].node.startDate
                            ))) ||
                    "Invliade start date"
            },
            isSaving: false,
            isLoadingQuery: false
        };
    },
    computed: {
        currentPhase() {
            if (this.growthTaskPhases) {
                const _phases = this.growthTaskPhases.filter(
                    item => item.node.isCurrentPhase
                );

                return _phases.length > 0
                    ? _phases[0].node
                    : {
                          phaseNo: 1,
                          greenhouseDepartmentSection: {},
                          startDate: new Date(),
                          endDate: new Date(),
                          confirmedDate: null
                      };
            } else return "";
        },
        greenhouseDepartmentSections() {
            var _sections = [];

            if (this.greenhouses.edges) {
                for (let greenhouse of this.greenhouses.edges) {
                    if (greenhouse.node.greenhouseDepartmentSet) {
                        for (let department of greenhouse.node
                            .greenhouseDepartmentSet.edges) {
                            if (
                                department.node.greenhouseDepartmentSectionSet
                            ) {
                                for (let section of department.node
                                    .greenhouseDepartmentSectionSet.edges) {
                                    _sections.push({
                                        id: section.node.id,
                                        name: section.node.name,
                                        fullName:
                                            greenhouse.node.name +
                                            "-" +
                                            department.node.name +
                                            "-" +
                                            section.node.name
                                    });
                                }
                            }
                        }
                    }
                }
            }

            return _sections;
        },
        taskStatus() {
            if (!this.currentPhase) {
                return;
            }

            // planned
            if (
                (!this.currentPhase.isSalesPhase &&
                    this.currentPhase.phaseNo === 1 &&
                    this.currentPhase.confirmedDate === null) ||
                this.growthTask.growthStartDate > this.todayStr
            ) {
                return "PLANNED";
            }

            // sales
            if (this.currentPhase.isSalesPhase) {
                return "SALES";
            }

            // growing
            return "GROWING";
        },
        taskColor() {
            if (this.growthTask && this.growthTask.totalInventory <= 0) {
                return "grey";
            }

            if (this.taskStatus === "PLANNED") {
                return "blue";
            }

            if (this.taskStatus === "GROWING") {
                return "success";
            }

            return "orange";
        },
        phaseRemainingWeeks() {
            if (this.taskStatus === "PLANNED") {
                return this.calculateWeeksBetweenDays(
                    this.currentPhase.startDate,
                    this.today
                );
            }

            return this.calculateWeeksBetweenDays(
                moment(this.currentPhase.endDate).add(1, "days"),
                this.today
            );
        },
        phaseRemainingDays() {
            if (this.taskStatus === "PLANNED") {
                return this.calculateDaysBetweenDays(
                    this.currentPhase.startDate,
                    this.today
                );
            }

            return this.calculateDaysBetweenDays(
                moment(this.currentPhase.endDate).add(1, "days"),
                this.today
            );
        },
        isReadyForNextPhase() {
            if (this.taskStatus === "SALES") {
                return false;
            }

            return this.phaseRemainingDays <= 0;
        },
        nextPhase() {
            if (this.taskStatus === "PLANNED" || this.taskStatus === "SALES") {
                return this.currentPhase;
            }

            const _nextPhases = this.growthTask.growthTaskPhaseSet.edges.filter(
                item => item.node.phaseNo == this.currentPhase.phaseNo + 1
            );

            return _nextPhases.length > 0
                ? _nextPhases[0].node
                : { greenhouseDepartmentSection: {} };
        }
    },
    methods: {
        calculateSpaceM2(numPlantsPerM2, quantity) {
            return numPlantsPerM2 > 0
                ? Math.ceil(quantity / numPlantsPerM2)
                : 0;
        },
        calculateWeeksBetweenDays(date1, date2) {
            const startOfWeek1 = moment(date1).startOf("isoweek");
            const startOfWeek2 = moment(date2).startOf("isoweek");

            return startOfWeek1.diff(startOfWeek2, "week");
            // return moment(day1).diff(day2, "week");
        },
        calculateDaysBetweenDays(day1, day2) {
            return moment(day1).diff(moment(day2), "day");
        },
        onUpdateTaskPlanConfirmed() {
            if (!this.$refs.updateTaskPlanForm.validate()) {
                return;
            }

            this.isSaving = true;

            let _totalGrowthDays = 0;
            let _maxSalesDays = 0;

            // calculate enddate of each phase
            this.growthTaskPhases.forEach((item, index) => {
                // for growth phase, use next phase's startDate as current phase's endDate
                if (index < this.growthTaskPhases.length - 1) {
                    item.node.endDate = moment(
                        this.growthTaskPhases[index + 1].node.startDate
                    )
                        .add(-1, "days")
                        .format("YYYY-MM-DD");

                    // item.node.numDays =
                    //     this.calculateDaysBetweenDays(
                    //         item.node.endDate,
                    //         item.node.startDate
                    //     ) + 1;

                    // console.log(
                    //     item.node.phaseNo,
                    //     item.node.isSalesPhase,
                    //     item.node.startDate,
                    //     item.node.endDate,
                    //     item.node.numDays
                    // );
                }

                // for sales phase, calculate endDate with maxSalesDays
                if (item.node.isSalesPhase) {
                    item.node.endDate = moment(item.node.startDate)
                        .add(item.node.numDays, "days")
                        .format("YYYY-MM-DD");

                    // console.log(
                    //     item.node.phaseNo,
                    //     item.node.isSalesPhase,
                    //     item.node.startDate,
                    //     item.node.endDate,
                    //     item.node.numDays
                    // );
                }

                // calcualte space m2
                item.node.spaceM2 = this.calculateSpaceM2(
                    item.node.numPlantsPerM2,
                    this.growthTask.totalInventory
                );

                // count total growth days and sales days
                if (item.node.isSalesPhase) {
                    _maxSalesDays += item.node.numDays;
                } else {
                    _totalGrowthDays += item.node.numDays;
                }
            });

            let _phases = this.growthTaskPhases.map(item => {
                return {
                    isSalesPhase: item.node.isSalesPhase,
                    phaseNo: item.node.phaseNo,
                    // isCurrentPhase: item.node.isCurrentPhase,
                    isCurrentPhase:
                        (item.node.phaseNo == 1 &&
                            moment(item.node.endDate).isSameOrAfter(
                                this.today,
                                "day"
                            )) ||
                        (item.node.isSalesPhase &&
                            moment(item.node.startDate).isSameOrBefore(
                                this.today,
                                "day"
                            )) ||
                        (moment(item.node.startDate).isSameOrBefore(
                            this.today,
                            "day"
                        ) &&
                            moment(item.node.endDate).isSameOrAfter(
                                this.today,
                                "day"
                            )),
                    startDate: item.node.startDate,
                    endDate: item.node.endDate,
                    numDays: item.node.numDays,
                    numPlantsPerM2: item.node.numPlantsPerM2,
                    spaceM2: item.node.spaceM2,
                    greenhouseDepartmentSectionNodeId:
                        item.node.greenhouseDepartmentSection.id
                };
            });

            // check if enddate valid

            const payload = {
                id: this.growthTask.id,
                numPhases: this.growthTask.numPhases,
                totalGrowthDays: _totalGrowthDays,
                maxSalesDays: _maxSalesDays,
                growthStartDate: moment(_phases[0].startDate).format(
                    "YYYY-MM-DD"
                ),
                growthEndDate: moment(
                    _phases[_phases.length - 2].endDate
                ).format("YYYY-MM-DD"),
                salesStartDate: moment(
                    _phases[_phases.length - 1].startDate
                ).format("YYYY-MM-DD"),
                salesEndDate: moment(
                    _phases[_phases.length - 1].endDate
                ).format("YYYY-MM-DD"),
                phases: _phases
            };

            this.$store
                .dispatch("growthTasks/updateGrowthTaskPhases", payload)
                .then(response => {
                    this.$emit("growthTaskPhasesUpdated", response);
                    // this.growthTask.tag = response.tag;
                    // this.$emit("update:growthTask", response);

                    this.closeUpdateTaskPlanDialog();
                })
                .catch(error => {
                    this.error = error.graphQLErrors[0].message;
                })
                .finally(() => {
                    this.isSaving = false;
                });
        },
        onPhaseStartDateChanged(phase) {
            phase.startDatePicker = false;

            // if phase no is not 1, then update previous phase NumDays
            if (phase.phaseNo > 1) {
                let previousPhase = this.growthTaskPhases.find(item => {
                    return item.node.phaseNo == phase.phaseNo - 1;
                });

                previousPhase.node.numDays = this.calculateDaysBetweenDays(
                    phase.startDate,
                    previousPhase.node.startDate
                );
            }

            // update following startDate of following phases
            let followingPhases = this.growthTaskPhases.filter(item => {
                return item.node.phaseNo > phase.phaseNo;
            });

            followingPhases.forEach((item, index) => {
                let prevNode = null;
                if (index === 0) {
                    prevNode = phase;
                } else {
                    prevNode = followingPhases[index - 1].node;
                }
                item.node.startDate = moment(prevNode.startDate)
                    .add(prevNode.numDays, "days")
                    .format("YYYY-MM-DD");
            });
        },

        onPhaseNumDaysChanged(phase) {
            // update following startDate of following phases
            let followingPhases = this.growthTaskPhases.filter(item => {
                return item.node.phaseNo > phase.phaseNo;
            });

            followingPhases.forEach((item, index) => {
                let prevNode = null;
                if (index === 0) {
                    prevNode = phase;
                } else {
                    prevNode = followingPhases[index - 1].node;
                }
                item.node.startDate = moment(prevNode.startDate)
                    .add(prevNode.numDays, "days")
                    .format("YYYY-MM-DD");
            });
        },
        addPhase() {
            // get sales phase
            let salesPhase = this.growthTaskPhases.find(item => {
                return item.node.isSalesPhase;
            });

            let days = 7;

            // add phase
            this.growthTaskPhases.push({
                node: {
                    phaseNo: this.growthTaskPhases.length,
                    startDate: salesPhase.node.startDate,
                    numDays: days,
                    isSalesPhase: false,
                    isCurrentPhase: salesPhase.node.isCurrentPhase,
                    greenhouseDepartmentSection: {}
                }
            });

            // update sales phase
            salesPhase.node.phaseNo = this.growthTaskPhases.length;
            salesPhase.node.isCurrentPhase = false;
            salesPhase.node.startDate = moment(salesPhase.node.startDate)
                .add(days, "days")
                .format("YYYY-MM-DD");

            // sort phases
            this.growthTaskPhases.sort((a, b) => {
                return a.node.phaseNo - b.node.phaseNo;
            });
        },
        deletePhase(phase) {
            // remove phase
            this.growthTaskPhases = this.growthTaskPhases.filter(
                item => item.node.phaseNo !== phase.phaseNo
            );

            // update following startDate of following phases
            let followingPhases = this.growthTaskPhases.filter(item => {
                return item.node.phaseNo > phase.phaseNo;
            });

            // update following phaseNo and start date
            followingPhases.forEach((item, index) => {
                if (index === 0) {
                    item.node.startDate = moment(phase.startDate).format(
                        "YYYY-MM-DD"
                    );
                    if (phase.isCurrentPhase) {
                        item.node.isCurrentPhase = true;
                    }
                } else {
                    let prevNode = followingPhases[index - 1].node;
                    item.node.startDate = moment(prevNode.startDate)
                        .add(prevNode.numDays, "days")
                        .format("YYYY-MM-DD");
                }
                item.node.phaseNo = item.node.phaseNo - 1;
            });
        },
        closeUpdateTaskPlanDialog() {
            this.$emit("plsCloseUpdateTaskPlanDialog", false);
            // this.growthTaskPhases = JSON.parse(
            //     JSON.stringify(this.growthTask.growthTaskPhaseSet.edges)
            // );
            this.growthTask = null;
        },
        //Function below will receive ID from father component and retrieve data for the given ID
        getGrowthTaskIdData(growthTaskid) {
            this.growthTasknumber = growthTaskid;
            this.isLoadingQuery = true;
            this.$apollo
                .query({
                    query: gql`
                        query growthTask($id: ID!) {
                            growthTask(id: $id) {
                                id
                                rawId
                                note
                                numPhases
                                plant {
                                    id
                                    name
                                    plantSpecies {
                                        id
                                        name
                                    }
                                    plantTagSet {
                                        edges {
                                            node {
                                                id
                                                tag {
                                                    id
                                                    tag
                                                    orderId
                                                }
                                            }
                                        }
                                    }
                                }
                                color {
                                    id
                                    color
                                }
                                potSize {
                                    id
                                    potSizeCm
                                }
                                environment {
                                    id
                                    environment
                                }
                                tag {
                                    id
                                    tag
                                }
                                plantGrowthTemplate {
                                    id
                                    name
                                }
                                supplier {
                                    id
                                    name
                                }
                                totalGrowthDays
                                maxSalesDays
                                growthStartDate
                                growthEndDate
                                salesStartDate
                                salesEndDate
                                lockedDate
                                lockedComment
                                lockedForCustomer {
                                    id
                                    name
                                }
                                closedDate
                                closedReason
                                supplierOrderNo
                                totalQuantity
                                totalInventory
                                unitPurchasePrice
                                currency
                                growthTaskPhaseSet {
                                    edges {
                                        node {
                                            id
                                            phaseNo
                                            startDate
                                            endDate
                                            numDays
                                            numPlantsPerM2
                                            spaceM2
                                            isSalesPhase
                                            isCurrentPhase
                                            remindedDate
                                            confirmedDate
                                            greenhouseDepartmentSection {
                                                id
                                                name
                                                greenhouseDepartment {
                                                    id
                                                    name
                                                }
                                            }
                                        }
                                    }
                                }
                                growthTaskInventoryLogSet(
                                    orderBy: "-createdAt"
                                ) {
                                    edges {
                                        node {
                                            id
                                            createdAt
                                            updatedBy
                                            change
                                            changeReason
                                            changeReasonTag {
                                                id
                                                tag
                                            }
                                            inventoryAfterChange
                                            refType
                                            refId
                                            comment
                                        }
                                    }
                                }
                                createdAt
                                updatedAt
                            }
                        }
                    `,
                    variables: {
                        id: this.growthTasknumber
                    },
                    // Additional options here
                    fetchPolicy: "network-only"
                })
                .then(response => {
                    this.growthTask = JSON.parse(
                        JSON.stringify(response.data.growthTask)
                    );

                    this.growthTaskPhases = JSON.parse(
                        JSON.stringify(
                            response.data.growthTask.growthTaskPhaseSet.edges
                        )
                    );
                })
                .catch(error => {
                    // Error
                    console.error(error);
                })
                .finally(() => {
                    // this.isSavingOrderPrintStatus = false;
                    this.isLoadingQuery = false;
                });
        }
    },
    created() {
        this.hasPermission = helper.hasPermission;
    }
};
</script>